import { render, staticRenderFns } from "./PageFunctions.vue?vue&type=template&id=67a914d7"
import script from "./PageFunctions.vue?vue&type=script&lang=js"
export * from "./PageFunctions.vue?vue&type=script&lang=js"
import style0 from "./PageFunctions.vue?vue&type=style&index=0&id=67a914d7&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67a914d7')) {
      api.createRecord('67a914d7', component.options)
    } else {
      api.reload('67a914d7', component.options)
    }
    module.hot.accept("./PageFunctions.vue?vue&type=template&id=67a914d7", function () {
      api.rerender('67a914d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/section/PageFunctions.vue"
export default component.exports